<template>
    <div class="block-amenities container" v-if="showing">
        <h2 class="headline-3">Accessibility & Amenities</h2>
        <ul aria-label="Amenities">
            <li v-if="site.fields['Family Accessible'] === 'Yes'">
                <SvgsAmenitiesFamily />
                <span>Family Friendly</span>
            </li>
            <li v-if="site.fields['Photography Permitted'] === 'Yes'">
                <SvgsAmenitiesPhotography />
                <span>Photography Allowed</span>
            </li>
            <li v-else-if="site.fields['Photography Permitted'] === 'No'">
                <SvgsAmenitiesPhotographyNotPermitted />
                <span>Photography Not Permitted</span>
            </li>
            <li v-if="site.fields['Washrooms Available'] === 'Yes'">
                <SvgsAmenitiesRestroom />
                <span>Restrooms Available</span>
            </li>
            <li v-else-if="site.fields['Washrooms Available'] === 'No'">
                <SvgsAmenitiesRestroomNotAvailable />
                <span>No Restrooms Available</span>
            </li>
            <li v-if="site.fields['Wheelchair Accessible'] === 'Yes'">
                <SvgsAmenitiesWheelchair />
                <span>Wheelchair Accessible</span>
            </li>
            <li v-else-if="site.fields['Wheelchair Accessible'] === 'No'">
                <SvgsAmenitiesWheelchairLimited />
                <span>Limited Accessibility</span>
            </li>
            <li v-if="site.fields['Refreshments Available Complimentary'] === 'Yes'">
                <SvgsAmenitiesRefreshmentsFree />
                <span>Refreshments Available</span>
            </li>
            <li v-if="site.fields['Refreshments Available for Sale'] === 'Yes'">
                <SvgsAmenitiesRefreshmentsBuy />
                <span>Refreshments for Purchase</span>
            </li>
        </ul>
    </div>
</template>

<script setup>
    const props = defineProps({
        site: {
            type: Object,
            required: true,
        },
    });
    const { site } = toRefs(props);

    const showing = computed(() => {
        if (site) {
            return (
                site.value.fields['Family Accessible'] ||
                site.value.fields['Washrooms Available'] ||
                site.value.fields['Wheelchair Accessible'] ||
                site.value.fields['Photography Permitted'] ||
                site.value.fields['Refreshments Available Complimentary'] ||
                site.value.fields['Refreshments Available for Sale']
            );
        }
    });
</script>

<style lang="scss" scoped>
    .block-amenities {
        margin-top: 32px;
        
        @media (min-width: 768px) {
            margin-top: 60px;
        }

        .headline-3 {
            margin-bottom: 16px;
        }
        
        li {
            display: flex;
            align-items: center;
            span {
                display: inline-block;
                margin-left: 12px;
            }
            + li {
                margin-top: 10px;
            }
        }
    }
</style>
